<template>
  <Layout style="background: #21343b" v-if="errerMessage !== ''">
    <p slot="logo" class="text-center mb-8">
      <v-img :src="logo" width="97" height="60" class="d-block ma-auto logo" @click="goMain" />
    </p>
    <p slot="desc" class="desc text-center mb-0" v-html="errerMessage"></p>
  </Layout>
  <Layout style="background: #21343b" v-else-if="passedWsInfo != null">
    <h2 slot="title" class="text-center" style="color: white">
      {{ $t('joinInvitedWorkspace', { wsName: passedWsInfo.wsName }) }}
    </h2>
    <p slot="desc" class="desc text-center mb-0">
      {{ $t('joinInvitedWorkspaceDesc') }}
    </p>
    <form slot="content" class="text-center mt-15">
      <v-container>
        <v-row>
          <v-col class="pt-0 pb-0 text-center">
            <v-avatar
              :color="(passedWsInfo.wsLogo === undefined ? passedWsInfo.wsName : '') | iconBackground"
              class="logo"
              rounded
              size="50"
              style="cursor: pointer"
            >
              <span class="white--text text-sm-h6 cent" v-if="!passedWsInfo.wsLogo">
                {{ passedWsInfo.wsName | iconFilter }}
              </span>
              <v-img :src="passedWsInfo.wsLogo" v-else />
            </v-avatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="company pt-0 pb-4 mt-3 mb-16 text-center">
            {{ passedWsInfo.wsName }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-btn
              block
              elevation="0"
              height="40"
              :disabled="isLoading"
              :loading="isLoading"
              :class="'btn-' + (!isLoading ? 'able' : 'disable')"
              id="setJoinWs"
              @click="setJoinWs"
            >
              {{ $t('join') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="showMsg">
          <v-col class="pt-0 pb-0 mt-5">
            <v-alert dense outlined :color="'#fff'">
              <span v-html="errorMessage" style="color: white" />
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </form>
    <loading-dialog :isLoading="isLoading"></loading-dialog>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { chkMagicLink, setWsAccept } from '@/services/api'
import logo from '@/assets/img/tape-logo.png'
export default {
  name: 'Invite',
  components: {
    Layout,
  },
  props: ['type'],
  data() {
    return {
      logo: logo,
      wsId: localStorage.getItem('passedWsId'),
      magicLinkCode: localStorage.getItem('magicLinkCode'),
      passedWsInfo: null,
      isLoading: false,
      showMsg: false,
      errorCode: '',
      errerMessage: '',
    }
  },
  created() {
    this.chkMagicLink()
  },
  beforeDestroy() {
    if (localStorage.getItem('passedWsId') !== null) localStorage.removeItem('passedWsId')
    if (localStorage.getItem('magicLinkCode') !== null) localStorage.removeItem('magicLinkCode')
  },
  methods: {
    goMain() {
      location.href = 'https://www.tape.ooo'
    },
    async chkMagicLink() {
      try {
        this.isLoading = true
        let result = await chkMagicLink(this, this.wsId, this.magicLinkCode)
        if (result.statusCode === '200') this.passedWsInfo = result.body
        else if (result.statusCode === '400') {
          this.errorCode = result.body
          this.errerMessage = this.$t('msgMagicLinkError')
        }
      } catch (error) {
        this.errorCode = typeof error.response !== 'undefined' ? error.response.data : error.message
        this.errerMessage = this.$t('msgMagicLinkError')
      } finally {
        this.isLoading = false
      }
    },
    async setJoinWs() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      try {
        await setWsAccept(this, this.passedWsInfo.wsId, this.magicLinkCode, undefined)
        await this.$store.dispatch('getUserWsList')
        if (localStorage.getItem('passedWsId') !== null) localStorage.removeItem('passedWsId')
        if (localStorage.getItem('magicLinkCode') !== null) localStorage.removeItem('magicLinkCode')
        this.$router.replace(`/${this.passedWsInfo.wsDomain}/my`).catch(() => {})
      } catch (error) {
        this.errorCode = typeof error.response !== 'undefined' ? error.response.data : error.message
        this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))

        console.log(this.errorCode, this.errorMessage)

        this.showMsg = true
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style scoped>
.logo {
  cursor: pointer;
}
.company {
  font-size: 24px;
  font-weight: 500;
  color: #ffffff !important;
  cursor: default;
}
</style>
